import React from "react";
import HeartSvg from "../svgs/HeartSvg";

interface ProductCardProps {
  image: string;
  name: string;
  price: number;
  stock: number;
}

const ProductCard: React.FC<ProductCardProps> = ({
  image,
  name,
  price,
  stock,
}) => {
  return (
    <div className="retail-product-card">
      <div className="retail-product-card__image-container">
        <img src={image} alt={name} className="retail-product-card__image" />
        <button className="retail-product-card__wishlist">
          <HeartSvg />
        </button>
      </div>
      <div className="retail-product-card__info">
        <h3 className="retail-product-card__name">{name}</h3>
        <p className="retail-product-card__price">
          <strong>${price.toFixed(2)}</strong> Per Unit
        </p>
        <p className="retail-product-card__stock">{stock} units left</p>
      </div>
    </div>
  );
};

export default ProductCard;
